import { emit } from "../utils/socketio";

export const getAllTopics = () => {
  return emit("getAllTopics");
};
